import React from 'react';
import SVG from 'react-inlinesvg';
import classnames from 'classnames';
import { IconNames } from '../../icons';
import styles from "./icon.module.css";
const baseClass = 'icon';
export const Icon = ({ className, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, name, role, title }) => {
    const size = name.endsWith('--small') ? 'small' : 'medium';
    const classes = classnames(styles[`${baseClass}--${size}`], className);
    return (React.createElement(SVG, { className: classes, role: role, title: title, "aria-hidden": ariaHidden, "data-testid": "icon-component", "aria-label": ariaLabel, src: IconNames[name] }));
};
//# sourceMappingURL=index.js.map